import { render, staticRenderFns } from "./PolygonalShape.vue?vue&type=template&id=fc70e9e0&"
import script from "./PolygonalShape.vue?vue&type=script&lang=js&"
export * from "./PolygonalShape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports